import React from 'react';

import { withStyles, WithStyles, createStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { units } from '@ha/dsl';

import { Page } from './types';

interface Props {
  page: Page;
  getPageHref: (p: number) => string;
  onPageChange: (p: Page) => void;
  children?: React.ReactNode;
}

const styles = createStyles({
  button: {
    margin: units.rem(0.2),
    padding: units.rem(0.2),
    minWidth: units.rem(2),
  },
});

class PagerButton extends React.PureComponent<
  Props & WithStyles<typeof styles>
> {
  handlePageChange: React.MouseEventHandler<HTMLElement> = event => {
    event.preventDefault();

    this.props.onPageChange(this.props.page);
  };

  render() {
    const {
      classes,
      children = null,
      page,
      getPageHref,
      onPageChange,
      ...rest
    } = this.props;

    return (
      <Button
        className={classes.button}
        size="small"
        variant={page.active ? 'contained' : 'outlined'}
        color={page.active ? 'primary' : undefined}
        component="a"
        href={getPageHref(page.num)}
        onClick={this.handlePageChange}
        data-test-locator={page.active ? 'Current Page Button' : 'Page Button'}
        {...rest}
      >
        {children || page.num}
      </Button>
    );
  }
}

export default withStyles(styles)(PagerButton);
